"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BY_CATEGORY = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var Category = _interopRequireWildcard(require("../Category"));

var ABM = _interopRequireWildcard(require("./ABM"));

var Accounting = _interopRequireWildcard(require("./Accounting"));

var Analytics = _interopRequireWildcard(require("./Analytics"));

var Automation = _interopRequireWildcard(require("./Automation"));

var CallCenter = _interopRequireWildcard(require("./CallCenter"));

var CMS = _interopRequireWildcard(require("./CMS"));

var CRM = _interopRequireWildcard(require("./CRM"));

var DataManagement = _interopRequireWildcard(require("./DataManagement"));

var ECommerce = _interopRequireWildcard(require("./ECommerce"));

var Email = _interopRequireWildcard(require("./Email"));

var ERP = _interopRequireWildcard(require("./ERP"));

var Event = _interopRequireWildcard(require("./Event"));

var HelpDesk = _interopRequireWildcard(require("./HelpDesk"));

var IPaaS = _interopRequireWildcard(require("./IPaaS"));

var KnowledgeBase = _interopRequireWildcard(require("./KnowledgeBase"));

var LeadGen = _interopRequireWildcard(require("./LeadGen"));

var LiveChat = _interopRequireWildcard(require("./LiveChat"));

var Payroll = _interopRequireWildcard(require("./Payroll"));

var PPC = _interopRequireWildcard(require("./PPC"));

var Project = _interopRequireWildcard(require("./Project"));

var Sales = _interopRequireWildcard(require("./Sales"));

var Scheduling = _interopRequireWildcard(require("./Scheduling"));

var SEO = _interopRequireWildcard(require("./SEO"));

var Social = _interopRequireWildcard(require("./Social"));

var Survey = _interopRequireWildcard(require("./Survey"));

var Ticketing = _interopRequireWildcard(require("./Ticketing"));

var Video = _interopRequireWildcard(require("./Video"));

var Webinar = _interopRequireWildcard(require("./Webinar"));

var Website = _interopRequireWildcard(require("./Website"));

var Wordpress = _interopRequireWildcard(require("./Wordpress"));

var Workflow = _interopRequireWildcard(require("./Workflow"));

var _BY_CATEGORY;

var BY_CATEGORY = (_BY_CATEGORY = {}, (0, _defineProperty2.default)(_BY_CATEGORY, Category.ABM, ABM), (0, _defineProperty2.default)(_BY_CATEGORY, Category.ACCOUNTING, Accounting), (0, _defineProperty2.default)(_BY_CATEGORY, Category.ANALYTICS, Analytics), (0, _defineProperty2.default)(_BY_CATEGORY, Category.AUTOMATION, Automation), (0, _defineProperty2.default)(_BY_CATEGORY, Category.CALL_CENTER, CallCenter), (0, _defineProperty2.default)(_BY_CATEGORY, Category.CMS, CMS), (0, _defineProperty2.default)(_BY_CATEGORY, Category.CRM, CRM), (0, _defineProperty2.default)(_BY_CATEGORY, Category.DATA_MANAGEMENT, DataManagement), (0, _defineProperty2.default)(_BY_CATEGORY, Category.ECOMMERCE, ECommerce), (0, _defineProperty2.default)(_BY_CATEGORY, Category.EMAIL, Email), (0, _defineProperty2.default)(_BY_CATEGORY, Category.ERP, ERP), (0, _defineProperty2.default)(_BY_CATEGORY, Category.EVENT, Event), (0, _defineProperty2.default)(_BY_CATEGORY, Category.HELP_DESK, HelpDesk), (0, _defineProperty2.default)(_BY_CATEGORY, Category.IPAAS, IPaaS), (0, _defineProperty2.default)(_BY_CATEGORY, Category.KNOWLEDGE_BASE, KnowledgeBase), (0, _defineProperty2.default)(_BY_CATEGORY, Category.LEAD_GEN, LeadGen), (0, _defineProperty2.default)(_BY_CATEGORY, Category.LIVE_CHAT, LiveChat), (0, _defineProperty2.default)(_BY_CATEGORY, Category.PAYROLL, Payroll), (0, _defineProperty2.default)(_BY_CATEGORY, Category.PPC, PPC), (0, _defineProperty2.default)(_BY_CATEGORY, Category.PROJECT, Project), (0, _defineProperty2.default)(_BY_CATEGORY, Category.SALES, Sales), (0, _defineProperty2.default)(_BY_CATEGORY, Category.SCHEDULING, Scheduling), (0, _defineProperty2.default)(_BY_CATEGORY, Category.SEO, SEO), (0, _defineProperty2.default)(_BY_CATEGORY, Category.SOCIAL, Social), (0, _defineProperty2.default)(_BY_CATEGORY, Category.SURVEY, Survey), (0, _defineProperty2.default)(_BY_CATEGORY, Category.TICKETING, Ticketing), (0, _defineProperty2.default)(_BY_CATEGORY, Category.VIDEO, Video), (0, _defineProperty2.default)(_BY_CATEGORY, Category.WEBINAR, Webinar), (0, _defineProperty2.default)(_BY_CATEGORY, Category.WEBSITE, Website), (0, _defineProperty2.default)(_BY_CATEGORY, Category.WORDPRESS, Wordpress), (0, _defineProperty2.default)(_BY_CATEGORY, Category.WORKFLOW, Workflow), _BY_CATEGORY);
exports.BY_CATEGORY = BY_CATEGORY;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/index.js
// module id = 141
// module chunks = 209 210 211 212 213